.container {
  .paginationWrapper {
    display: flex;
    flex-grow: 1;
  }
}

.tableEmpty {
  td {
    border-bottom: none !important;
  }
}

.expandedRowClassName {
  > td {
    background: var(--ant-color-white) !important;
  }
}

.copyIcon {
  font-size: var(--ant-font-size-lg);
  flex-shrink: 0;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
}

.copyableCell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ant-margin-xs);
  position: relative;

  &:hover {
    .copyIcon {
      opacity: 1;
    }
  }
}

.paginationControls {
  display: flex;
  justify-content: center;
  gap: var(--ant-margin);
  margin-top: var(--ant-margin);
}

.noRelatedResult {
  font-weight: var(--ant-font-weight-strong);
  color: var(--ant-color-text-secondary);
}

.noRelatedImage {
  margin: 0;
}

.noRelatedImage svg {
  width: 120px;
  height: 70px;
}

.evenRow {
  background-color: var(--ant-cellgrey-bg);
}
